$(document).ready(function(){

  var rtlLocales = ['/ar-kw', '/ar-ae','/ar-sa'];

  var isRTL = rtlLocales.some(function (path) {
    return window.location.pathname.startsWith(path);
  });

   if ($(window).scrollTop() > 400) {
      $('.go-top').addClass('showw');
    } else {
      $('.go-top').removeClass('showw');
    }

    $('.go-top').on('click', function (e) {
      e.preventDefault();
      console.log('clickck')
      $('html, body').animate({ scrollTop: 0 }, 600); // 600 = speed in ms
    });

  if((window.location.href.includes('sort_by') || window.location.href.includes('page')) && $("#CollectionAjaxContent").length > 0){  
    window.scrollTo({top: $("#CollectionAjaxContent").offset().top, behavior: 'smooth'});
    // $('html, body').animate({
    //   scrollTop: $("#CollectionAjaxContent").offset().top
    // }, 3000);
  } 

  if ($('#saleendsin').length > 0) {
    // Input string (assumed to be in PDT)
    var pdtInput = $('#saleendsin').attr('data-expired_date');
    var pdtDate = new Date(pdtInput);
    var countDownDate = pdtDate.getTime();
  
    var x = setInterval(function () {
      const now = new Date();

      // Get PDT-localized date and time string in en-US format
      const pdtString = now.toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
      });
      
      // Parse that PDT string back into a Date object
      const pdtDate2 = new Date(pdtString);
      
      // Get the timestamp in milliseconds
      const pdtTimestamp = pdtDate2.getTime();
      
      // var now = new Date().getTime();
      var distance = countDownDate - pdtTimestamp;
  
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      if (hours < 10) hours = '0' + hours;
  
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if (minutes < 10) minutes = '0' + minutes;
  
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (seconds < 10) seconds = '0' + seconds;
  
      document.getElementById("saleendsin").innerHTML =
        '<span class="value">' + days + '<span class="timelabel">Days</span></span><span>:</span>' +
        '<span class="value">' + hours + '<span class="timelabel">Hours</span></span><span>:</span>' +
        '<span class="value">' + minutes + '<span class="timelabel">Minutes</span></span><span>:</span>' +
        '<span class="value">' + seconds + '<span class="timelabel">Seconds</span></span>';
  
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("timer_wrapper").style.display = "none";
      }
    }, 1000);
  }
  
  if($(window).width() < 768 && jQuery('.lang_selector .multi-selectors').length > 0){
    var get_lang = jQuery('.lang_selector .multi-selectors').detach();
    $('.mobile_lang_switcher').append(get_lang);
  }
  
  $('body').on('click','.left-arrow', function(){
    $(this).closest('.clsw-container').find('.slick-prev').click();
  })
  $('body').on('click','.right-arrow', function(){
    $(this).closest('.clsw-container').find('.slick-next').click();
  })

  $(".header-item predictive-search #Search").focus(function(){
      $(this).closest('.search__input-wrap').addClass('active');
  }).blur(function(){
      $(this).closest('.search__input-wrap').removeClass('active');
  }).focusout(function(){
      $(this).closest('.search__input-wrap').removeClass('active');
  });

  //set cookie
  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
      
  $('body').on('click','.ctryModal-Content .stay_here_button', function(){
    $(".ctryModal-Content-overlay").removeClass('active');
    $(".ctryModal-Content").removeClass('active');
    $("body").removeClass('overflow-hidden');
    var delaydays = parseInt($(this).closest('.ctryModal-Content').attr('data-delaydays'));
    setCookie('redirectchoice',true,delaydays);
  });

  
  // TESTIMONIAL SLIDER 
  $('.testi-secon-block-list').slick({
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: isRTL,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          centerPadding:'100px'
        }
      }
    ]
  });

  $('.article .article_related_products .article_flex_slider').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 600,
    slidesToShow: 1,
    rtl: isRTL,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256 0C114.837 0 0 114.837 0 256s114.837 256 256 256 256-114.837 256-256S397.163 0 256 0zm57.749 347.584c8.341 8.341 8.341 21.824 0 30.165A21.275 21.275 0 0 1 298.666 384a21.277 21.277 0 0 1-15.083-6.251L176.917 271.083c-8.341-8.341-8.341-21.824 0-30.165l106.667-106.667c8.341-8.341 21.824-8.341 30.165 0s8.341 21.824 0 30.165L222.165 256l91.584 91.584z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256 0C114.837 0 0 114.837 0 256s114.837 256 256 256 256-114.837 256-256S397.163 0 256 0zm79.083 271.083L228.416 377.749A21.275 21.275 0 0 1 213.333 384a21.277 21.277 0 0 1-15.083-6.251c-8.341-8.341-8.341-21.824 0-30.165L289.835 256l-91.584-91.584c-8.341-8.341-8.341-21.824 0-30.165s21.824-8.341 30.165 0l106.667 106.667c8.341 8.341 8.341 21.823 0 30.165z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg></button>'
  });

  // ADDED BY LANGIFY 2024-04-19 to make it multilingual _BEGIN_
  $('body').on('click','.colll_read_more', function(){
    if ($('.colll_read_more').text() == "Read More") {
      $(this).text("Read Less")
    } else if ($('.colll_read_more').text() == "Mehr lesen") {
      /*German*/
      $(this).text("Weniger lesen")
    } else if ($('.colll_read_more').text() == "Leer más") {
      /*Spanish*/
      $(this).text("Leer menos")
    } else if ($('.colll_read_more').text() == "Lire plus") {
      /*French*/
      $(this).text("Lire moins")
    } else if ($('.colll_read_more').text() == "Meer lezen") {
      /*Dutch*/ 
      $(this).text("Minder lezen")
    } else if ($('.colll_read_more').text() == "Leggi di più") {
      /*Italian*/
      $(this).text("Leggi di meno")
    }   
    else {
      $(this).text("Read More")
    }
    $(this).closest('.coll_description_wrap').find('.collection__description').toggleClass('full-description')
  })
// ADDED BY LANGIFY 2024-04-19 to make it multilingual _END_
  
   // TEAM MEMBER SLIDER
  $('.team-m-wrap-list').slick({
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: isRTL,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          centerPadding:'100px'
        }
      }
    ]
  });

  $('.custom-blogs_wrapper').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    rtl: isRTL,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: isRTL
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rtl: isRTL
        }
      }
    ]
  });

  $('a[data-href]').click(function(){
     var url = $(this).attr('data-href');
      window.open(url, '_blank');
  });
  $('.yt-videos_wrapper').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    rtl: isRTL,
    responsive: [
      {
        breakpoint: 769,
        settings: "unslick",
      }
    ]
  });

  // PRODUCT OFFERS COPY CODE
  $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });

  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this);
    var text = $(this).parent().find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  // Clear URL parameters without reloading the page
  function clearURLParameters() {
    // Get the current URL
    const url = new URL(window.location.href);
  
    // Remove all query parameters
    url.search = "";
  
    // Optionally, remove the fragment (everything after #)
    url.hash = "";
  
    // Update the URL without reloading the page
    window.history.replaceState(null, null, url.toString());
  }
  
  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var resultischal = live_url.includes('/challenge');
  if(result && !resultischal && $('#newsletter-footer').length != 0 && $('#newsletter-footer .errors').length == 0){
      const add_ele = document.createElement("p");
      add_ele.innerText = "You have already subscribed!";
      $('#newsletter-footer').prepend(add_ele);
      add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
      // if($(window).width() < 767){
      //   setTimeout(function(){
      //     console.log('ldoiiiddd')
      //     console.log($('.footer_newsletter_trigger').length);
      //     $('.footer_newsletter_trigger').trigger('click'); 
      //   },1000);       
      // }      
      clearURLParameters();
  }
  if(live_url.includes('/challenge')){
    setTimeout(function(){
      window.scrollTo({top: 0, behavior: 'smooth'});
    },2000);    
  }
  
  // PDP Product Tabs  
  $("body").on("click",".btn-tab-pro", function(){
    var btnId = $(this).attr('data-pro');
    if($(this).hasClass('activee')){
      $(this).closest('.pdp-tab-slct-optn-tabs').find('.btn-tab-pro').removeClass('activee')
      $(this).closest('.pdp-tab-slct-optn-wrap').find('.pdp-tab-slct-optn-pro-blck').addClass('hide');
    }else{
      $(this).closest('.pdp-tab-slct-optn-tabs').find('.btn-tab-pro').removeClass('activee')
      $(this).addClass('activee')
      $(this).closest('.pdp-tab-slct-optn-wrap').find('.pdp-tab-slct-optn-pro-blck').addClass('hide');
      $(this).closest('.pdp-tab-slct-optn-wrap').find('[data-list="'+btnId+'"]').removeClass('hide');  
    }
    
  })
  

  // FBT Section
    $('body').on('click','.fbt-product-bundle__cta', function(){    
    var _this = $(this);
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    var items = [];    
    $(this).closest('.fbt-wrapper').find('.fbt-item').each(function(i,v){
       var val = $(this).attr('data-vid');         
       items.push({
        quantity: 1,
        id: val
      });          
    });    
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      _this.removeAttr("disabled");
      _this.removeAttr("aria-busy");     
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));      
    }.bind(this));  
  }); 

  $('body').on('click','.js_remove_wrapper .js-qty__remove', function(){
    var _this = this;
    $(_this).addClass('is-loading');
    const line = $(this).attr('data-id'); // Ensure it's an integer
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: line,
        quantity: 0
      },
      dataType: 'json',
      success: function(cart) {
        if($('body').hasClass('template-cart')){
          window.location.reload();
        }else{
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          $(_this).removeClass('is-loading');
        }
        
      },
      error: function(err) {
        console.error('Cart item remove failed', err);
        $(_this).removeClass('is-loading');
      }
    });
  });

  // FOOTER
  var width = $(window).outerWidth();
  if(width<=999){
    $(".footer__item--newsletter_ARMK9X.newsletter-6 .collapsible-trigger-btn").click();
  }

  $('body').on('click','.article__body .article-nav-section a', function(){
    var selectr = $(this).attr('data-toscroll');
    var mm = $(this).closest('.article__body').find('.body_content h2.'+selectr);
    if(mm.length > 0){
     window.scrollTo({top: mm.offset().top, behavior: 'smooth'});
    }    
  });

  if($(window).width() < 740){
    var header = $(".article__body .article-nav-section");
    var offtop = header.offset().top;
    $(window).scroll(function() {    
      if (window.pageYOffset > offtop) {
        header.addClass("fixed");        
      } else {
        header.removeClass("fixed");
      }
    }); 
  }   

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  
  if($(".product-single__meta .sticky_atc_wrapper").length > 0){
   var header = $(".product-single__meta .sticky_atc_wrapper");
    if ($(".product-single__meta .buybutton_block").isInViewport()) {      
      header.removeClass("is-fixed");
      header.closest('.product-block').removeAttr('style');
    }else{      
       header.addClass("is-fixed");
       header.closest('.product-block').attr('style','padding-top: '+ header.outerHeight() +'px;');
    }
     $(window).scroll(function() {    
      if ($(".product-single__meta .buybutton_block").isInViewport()) {      
        header.removeClass("is-fixed");
        header.closest('.product-block').removeAttr('style');
      }else{      
         header.addClass("is-fixed");
         header.closest('.product-block').attr('style','padding-top: '+ header.outerHeight() +'px;');
      }
     }); 
  }  

  $('body').on('change','.article__body .article-nav-section .scroll_selector', function(){
    var selectr = $(this).val();
    console.log(selectr);
    var mm = $(this).closest('.article__body').find('.body_content h2.'+selectr);
    if(mm.length > 0){
     window.scrollTo({top: mm.offset().top - 80, behavior: 'smooth'});
    }    
  });

  if (window.matchMedia('(min-width: 768px)').matches){
    $('.pdp-tab-img-wrap').each(function(){
        tippy(this, {
          content: this.querySelector('.pdp-tab-img-tooltip_main').cloneNode(true),
          arrow: true,
          animation: 'shift',
          size: 'regular',
          theme: 'light',
          distance: 15,
          animateFill: true
      });
    });
  }
  
})

$("body").on("click", ".pro-faq-tab-cor-btn", function() {
  $(this).toggleClass("active");
  $(this).siblings(".pro-faq-tab-cor-cotent").slideToggle();
  $(this).siblings(".pro-faq-tab-cor-cotent").toggleClass("active");
  $(this).siblings(".pro-faq-tab-cor-cotent").find(".collapsible-content__inner").toggleClass("active");
})
$("body").on("click", ".pro-faq-tab-item-title", function () {
    var activeTitle = $(this);
    activeTitle.toggleClass("active");
    var currentDropdown = activeTitle.next(".pro-faq-tab-item-text");
    $(".pro-faq-tab-item-title").not(activeTitle).removeClass("active");
    $(".pro-faq-tab-item-text").not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
});

if($('.collection-filter').length > 0){
  var filterTop = $('.collection-filter').offset().top;

  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= filterTop) {
      $('.collection-filter').addClass('fixed');
    } else {
      $('.collection-filter').removeClass('fixed');
    }
  });
}


$(window).on('scroll resize', function () {
  if ($(window).scrollTop() > 400) {
    $('.go-top').addClass('showw');
  } else {
    $('.go-top').removeClass('showw');
  }
});

// if($('.collection-filter').length > 0){
//   var mobilefacetbar = $('.collection-filter').offset().top;
//   $(window).on('scroll', function() {
//     if ($(this).scrollTop() > mobilefacetbar) {
//       $('.collection-filter').addClass('fixed');
//     } else {
//       $('.collection-filter').removeClass('fixed');
//     }
//   });  
// }
